import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import FormInputs from '../../components/UI/FormInputs'
import { fetchTimeInterval, getCurrentTime, isSet } from '../../utils/commonUtils';
import RandomGeneratorConfigService from '../../services/RandomGeneratorConfigService';
import WithRoutify from '../../hoc/WithRoutify';
import withReduxState from '../../hoc/wReduxState';
import OrganizationService from '../../services/OrganizationService';
import { useSelector } from 'react-redux';
import { organizationList } from '../../store/OrganizationSlice';
import DropDownService from '../../services/DropDownService';
import CompanyService from '../../services/CompanyService';
import WithDropdownState from '../../hoc/WithDropdownState';

const AddRandomVisitScheduler = (props) => {
  const { payload, addFormHandler ,fetchrandomVisitSchedulerList , visitCategory ,Loader} = props;
  const activeEditId = payload?.id;
  const organizationListOptions = useSelector(organizationList);
  const [activityList, setActivityList] = useState([]);
  const [isHide,setIsHide] = useState(true);
  const [formData, setFormData] = useState({
    company_id: "",
    visit_category: "",
    standard_services: "",
    optional_services: [],
    patient_selection_type: "",
    selection_number: "",
    is_notify_employee: true,
    schedule_type: "ONCE",
  });
  const [validation, setValidation] = useState({});
  const [activeTab, setActiveTab] = useState("ONCE");
  const [services, setService] = useState([]);
  const [companyOptions, setCompanyOption] = useState([]);
  const [companyServiceOption, setCompanyServiceOption] = useState([{ label: '-Select Service-', value: '' }]);

  const [ScheduleForm, setScheduleForm] = useState({
    start_date: "",
    start_time: "",
    repeat_type: "",
    starts_at: "",
    ends_type: "",
    ends_date: "",
    end_time: "",
    custom_cron_expression: "",
  });
  const PatientSelectionTypeoptions = [
    { label: "Whole", value: "whole" },
    { label: "Percentage", value: "percentage" },
  ]
  const subtabs = [
    { id: "ONCE", label: "Once" },
    { id: "SETINTERVAL", label: "Set Interval" },
    { id: "CRON", label: "Cron Expression" },
  ];
  const repeatTypeOptions = getRepeatTypeOptions()
  const days = getDays()
  const months = getMonths();
  const Weekday = getWeekday();

  // intial render
  useEffect(() => {
    if (props.payload) {
      const { payload } = props;
      const activeEditId = payload.id;
      console.log('payload', payload);
      Loader(true);
      RandomGeneratorConfigService.getRandomVisitSchedulerById(activeEditId)
        .then((response) => {
          console.log('getRandomVisitSchedulerById response', response);
          setFormData({
            company_id: isSet(response.company_id, ""),
            visit_category: isSet(response.visit_category, ""),
            standard_services: isSet(response.standard_services, ""),
            optional_services: isSet(response.optional_services, []),
            patient_selection_type: isSet(response.patient_selection_type, ""),
            selection_number: isSet(response.selection_number, ""),
            is_notify_employee: isSet(response.is_notify_employee, ""),
            schedule_type: isSet(response.schedule_type, "ONCE"),
          })
          if(isSet(response.optional_services,"")!==""){
          setService(isSet(response.optional_services.split(','), []))
          }
          setActiveTab(isSet(response.schedule_type, "ONCE"));
          setScheduleForm({
            start_date: isSet(response.start_date, ""),
            start_time: isSet(response.start_time, ""),
            repeat_type: isSet(response.repeat_type, ""),
            starts_at: isSet(response.starts_at, ""),
            ends_type: isSet(response.ends_type, ""),
            ends_date: isSet(response.ends_date, ""),
            end_time: isSet(response.end_time, ""),
            custom_cron_expression: isSet(response.custom_cron_expression, ""),
          });
          if( response.visit_category === "Employer Services - Labs" || response.visit_category === "Urgent Care - Labs Only") {
            setIsHide(true);
          }else{
            setIsHide(false);
          }
        })
        .finally(()=>{
          Loader(false);
        });
    }
  }, []);

  //
  useEffect(() => {
    fetchCompaniesList();
    fetchActivities();
  }, [formData.organization_id])

  //
  useEffect(() => {
    fetchCompanyServiceOptions(formData.company_id);
  }, [formData.company_id])


  //api calls
  const fetchCompaniesList = async () => {
    Loader(true);
    const response = await DropDownService.getCompanies(isSet(formData.organization_id, null));
    Loader(false);
    let companiesOptions = [{ label: "-Select Company-", value: "" }];
     response && response.forEach((company) => {
      companiesOptions.push({
        label: company.name,
        value: company.company_uuid,
      });
    });
    setCompanyOption(companiesOptions);
  };

//
  const fetchCompanyServiceOptions = async (company_id) => {
    if (!company_id) return false;
    Loader(true);
    let companyPhysical = await CompanyService.getCompaniesPhysicalByOrg(isSet(formData.organization_id,null),company_id);
    Loader(false);
    let opt = [{ label: '-Select Service-', value: '' }];
    const companyPhysicalData = companyPhysical?.data?.data;
   companyPhysicalData && companyPhysicalData.forEach((itm) => {
      opt.push({ label: itm.physical_name, value: itm.physical_name })
    });
    console.log('companyPhysicalData', companyPhysical);
    setCompanyServiceOption(opt);

  }
  //fetch activity 
      const fetchActivities = async () => {
     try{
        Loader(true);
        const response = await DropDownService.getActivityDropdownList(isSet(formData.organization_id, null));
        Loader(false);
        let opt = [{ "label": 'ALL', value: 'ALL' }];
           response && response.forEach((itm, ind) => {
              opt.push({ label: itm.activity_name, value: itm.actitivity_id,activity_type: itm.activity_type})
            });
        setActivityList(opt);
      }catch (error) {
        console.error("Error fetching activities: ", error);
      }
    }

  //
  const inputForms = [
    {
      type: "SelectSearchList",
      label: "Company",
      placeholder: "Company",
      className: "form-control form-control-solid",
      name: "company_id",
      options: companyOptions,
      value: "",
      required: true,
      col: "col-4"
    },

    {
      type: "SelectSearchList",
      label: "Patient Selection Type",
      placeholder: "",
      className: "form-control form-control-solid",
      name: "patient_selection_type",
      options: PatientSelectionTypeoptions,
      value: "",
      required: true,
      col: "col-4"
    },
    {
      required: true,
      type: "Number",
      label: "No Of Appoinments",
      placeholder: "No Of Appoinments",
      className: "form-control form-control-solid",
      name: "selection_number",
      col: "col-4",
      required: true, 
    },
    {
      type: "SelectSearchList",
      label: "Visit Category",
      placeholder: "Visit Category",
      className: "form-control form-control-solid",
      name: "visit_category",
      value: "",
      options: visitCategory,
      col: "col-4",
      required: true
    },
    {
      type: "SelectList",
      label: "Standard Service",
      options: companyServiceOption,
      placeholder: "",
      className: "form-control form-control-solid",
      name: "standard_services",
      //required: true,
      col: "col-4"
    },
    {
      type: "Checkbox",
      label: "Send Notification to Employer",
      className: "mr-1",
      name: "is_notify_employee",
      col: "col-4"
    },
    {
      type: "MultiSelectDropDown",
      options: activityList,
      className: "form-control form-control-solid",
      name: "optional_services",
      label: "Optional Services",
      col:'col-12',
    },
  ];
  if (isSet(props.profile.is_multiple_organization, false) === true && !activeEditId) {
    inputForms.unshift(
      {
        type: "Blank",
        col: "col-6",
        className: "form-control form-control-solid",
      }
    );
    inputForms.unshift(
      {
        type: "SelectList",
        label: "Organization",
        col: "col-6",
        options: organizationListOptions,
        placeholder: "",
        className: "form-control form-control-solid",
        name: "organization_id",
        value: isSet(formData.organization, OrganizationService.getOrgId()),
        required: true
      }
    );
  }

  //change handler
  const changeHandler = (val, fieldName, e) => {
    const exisitingdata={...formData}
    if( fieldName === "visit_category") {
    if(val === "Employer Services - Labs" || val==="Urgent Care - Labs Only" || val==="") {   
        exisitingdata["optional_services"]=[];
        exisitingdata["standard_services"]="";
        setIsHide(true);
    }else{
        setIsHide(false);
    }}
    if (fieldName === "optional_services") {
      serviceOnchangeHandler(fieldName, val, e);
      return
    }
    setFormData({
      ...exisitingdata,
      [fieldName]: val,
    });
    setValidation({ ...validation, [fieldName]: "" });
  };
  const serviceOnchangeHandler = (name, bool, { selectVal }) => {
    let updatedServices = [...services];
    if (bool) {
      if (selectVal === 'ALL') {
        updatedServices = ['ALL'];
      } else {
        updatedServices.push(selectVal);
      }
    } else {
      if (selectVal === 'ALL') {
        updatedServices = [];
      } else {
        let isSelected = services.includes('ALL');
        if (isSelected) {
          updatedServices = activityList.map(itm => itm.value).filter(itm => itm !== selectVal && itm != 'ALL');
        } else {
          updatedServices = updatedServices.filter((value) => value !== selectVal);
        }
      }
    }
    if (activityList.length - 1 == updatedServices.length) {
      updatedServices = ['ALL'];
    }
    setFormData({
      ...formData,
      ["optional_services"]: updatedServices,
    });
    setService(updatedServices);
  };
  const changeTabHandler = (tab) => {
    setActiveTab(tab);
    setScheduleForm({
      start_date: "",
      start_time: "",
      repeat_type: "",
      starts_at: "",
      ends_type: "",
      ends_date: "",
      end_time: "",
      custom_cron_expression: "",
    });
    changeHandler(tab, "schedule_type", "");
  };
  const ScheduleFormHandler = (val, fieldName, e) => {
    console.log("Schedule Form Handler Value: ", val, "Field Name: ", fieldName, "Event: ", e);
    setScheduleForm(prev => ({
      ...prev,
      [fieldName]: val,
    }));
    setValidation({ ...validation, [fieldName]: "" });
  }
  const endsHanlder = (val, fieldName, e) => {
    setScheduleForm(prev => ({
      ...prev,
      ends_date: "",
      end_time: "",
    }));
    ScheduleFormHandler(val, fieldName, e);
  }

  //save
  const handleSave = async () => {
    props.Loader(true)
    if (isSet(props.profile.is_multiple_organization, false) === true && organizationListOptions.length > 2 && !activeEditId) {
      //check organization filled if no throwing validation
      if (isSet(formData.organization_id, false) == false) {
        setValidation({
          ...validation,
          ['organization_id']: 'The Organization Field is Required',
        });
        props.Loader(false)
        return false
      }
    }
    try {
      const optionalServices = typeof formData.optional_services === 'string' ? formData.optional_services : formData.optional_services.join(',');
      const payload = {
        ...formData,
        ['optional_services']: optionalServices,
        ...ScheduleForm
      }
      let response;
      if (activeEditId) {
        response = await RandomGeneratorConfigService.updateRandomGeneratorConfig(isSet(formData.organization_id, null),
          props.payload.id, payload)
      }
      else {
        response = await RandomGeneratorConfigService.saveRandomGeneratorConfig(isSet(formData.organization_id, null),
          payload)
        
      }
      if(response.code == 200 ){
        props.Toast.success("Appoinment Updated Succesfully");
        fetchrandomVisitSchedulerList();
        addFormHandler(true);
      }
      if (response.code == 201) {
        props.Toast.success("New Appoinment Added Succesfully");
        fetchrandomVisitSchedulerList();
        addFormHandler(true);
      } else if (response.code == 422) {
        //handle validation 
        setValidation(response.data);
      }
    } catch (error) {
      console.error("Error in handleSave: ", error);
      props.Toast.error("something went wrong, please try again later");
    }
    finally {
      props.Loader(false);
    }
  }
  return (
    <Modal
      show={props.isOpen}
      onHide={()=>addFormHandler(true)}
      size="xl"
      dialogClassName="hResponsive"
      contentClassName="h-100"
      backdrop="static"
      keyboard={false}
    >
      <div className="sh_modalBox">
        <Modal.Header closeButton>
          <Modal.Title>
            <h6 className="font-weight-bold text-lg mb-0">Schedule New Appoinment</h6>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row px-2">
            <div className="col-12">
              <h6 className="text-md border-bottom pt-3 ">Visit details</h6>
              <div className="row">
                {inputForms.map((field, index) => {
                  if((field.name ==="optional_services" || field.name==="standard_services") && isHide===true){
                    return false}
                 return( 
                  <div className={field.col} key={index}>
                    <div className={field.col === "col-12" ? "form-group" : "form-group"}>
                      {(isSet(field.isLabelAppend && field.isLabelAppend, false) === false) ?
                        <label className="mb-0 text-sm opacity-75 text-truncate">
                          {field.label}
                        </label>
                        : <></>}
                      <div
                        className={field.type == 'MultiSelectDropDown' ? 'd-flex muliselect-validation' : ''}
                        key={index}
                      >
                        <FormInputs
                          {...field}
                        //  className ={isSet(field.className ,"form-control form-control-solid")}
                          placeholder ={isSet(field.placeholder ,field.label)}
                          changeHandler={(value, e) =>
                            changeHandler(value, field.name, e)
                          }
                          value={formData[field.name]}
                        />
                        {isSet(validation[field.name], "") !== "" ? (
                          <span className="text-danger m-1">
                            {isSet(validation[field.name], "")}
                          </span>
                        ) : (
                          ""
                        )}
                        {(isSet(field.isLabelAppend && field.isLabelAppend, false) === true) ?
                          <label className="form-check-label" htmlFor={field.name}>
                            {field.label}
                          </label>
                          : <></>}
                      </div>
                    </div>
                  </div>
            )})}

              </div>
              <h6 className="text-md border-bottom pt-3 ">Schedule Appoinment</h6>
              <div className="row">
                <div className="col-12">
                  <div className="card mt-3 mb-0 shadow_new border-0">
                    <div className="card-header p-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <ul className="nav nav-pills nav-secondary nav-pills-no-bd" id="pills-tab" >
                          {subtabs.map((tab, index) => (
                            <li className="nav-item" role="presentation" key={index}>
                              <a className={activeTab === tab.id ? `cursor-pointer nav-link text-light active` : "cursor-pointer nav-link text-light"} onClick={() => changeTabHandler(tab.id)} id={tab.id} >{tab.label}</a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <div className="tab-content px-3 " id="pills-tabContent">
                      {activeTab === 'ONCE' && 
                      <div className="tab-pane fade show active " id="once" >
                        <div className='row'>
                          <div className="form-group col-8 px-0 pt-3">
                            <label className="mb-0 text-sm opacity-75 text-truncate">Set Data & Time</label>
                                <div className=' w-100 row'>
                                  <div className='col-6'>
                                  <FormInputs
                                    type="Date" disablePast={true} required="true" id="" className=" form-control " placeholder="Set Data" value={ScheduleForm["start_date"]} changeHandler={(value, e) => ScheduleFormHandler(value, "start_date", e)}
                                  />
                                  {isSet(validation["start_date"], "") !== "" ? (
                                    <span className="text-danger m-1">
                                      {isSet(validation["start_date"], "")}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                  </div>
                                  <div className='col-6'>
                                  <FormInputs
                                    type="SelectSearchList" required="true" id="" className="form-control" placeholder="Set Time" value={ScheduleForm["start_time"]} changeHandler={(value, e) => ScheduleFormHandler(value, "start_time", e)}
                                    isAsync="true"
                                    options={[{ 'label': getCurrentTime(), value: getCurrentTime() }]}
                                    loadCallBack={(val, callback) => fetchTimeInterval(val, callback)}
                                    name="set_time"
                                  />
                                   {isSet(validation["start_time"], "") !== "" ? (
                                    <span className="text-danger m-1">
                                      {isSet(validation["start_time"], "")}
                                    </span>
                                  ) : (
                                    ""
                                  )}</div>
                              </div>
                          </div>
                        </div>
                      </div>
                      }
                      {activeTab === 'SETINTERVAL' && <div className="tab-pane fade show active" id="set-interval" >
                        <div className="row">
                          <div className="form-group col-3">
                            <label className="mb-0 text-sm opacity-75 text-truncate">Repeat</label>
                              {/* <div className="w-50 pr-1">
                                      <FormInputs
                                         type="SelectList" id="" className="form-control form-control-solid"  value={ScheduleForm["repeat_no"]} changeHandler={(value, e) => ScheduleFormHandler(value, "repeat_no", e) }
                                                   options= {numberOptions}
                                                   name= "repeat_no" />
                                    
                                 </div> */}
                              {/* <div className="w-50 pr-1">
                                    <select className="form-control form-control-solid " name="" id="">
                                       <option value="">Monday</option>
                                       <option value="">Tuesday</option>
                                       <option value="">Wednesday</option>
                                       <option value="">Thursday</option>  
                                       <option value="">Friday</option>
                                       <option value="">Saturday</option>
                                       <option value="">Sunday</option>
                                    </select>  
                                 </div>  */}
                              {/* <div className="w-50 pr-1">
                                    <select className="form-control form-control-solid " name="" id="">
                                       <option value="">January</option>
                                       <option value="">February</option>
                                       <option value="">March</option>
                                       <option value="">April</option>  
                                       <option value="">May</option>
                                       <option value="">June</option>
                                       <option value="">July</option>
                                       <option value="">August</option>  
                                       <option value="">September</option>
                                       <option value="">October</option>
                                       <option value="">November</option>
                                       <option value="">December</option>
                                    </select>  
                                 </div>  */}
                              <div className="w-100 pl-1">
                                <FormInputs
                                  type="SelectList" id="" className="form-control form-control-solid" value={ScheduleForm["repeat_type"]} changeHandler={(value, e) => ScheduleFormHandler(value, "repeat_type", e)}
                                  options={repeatTypeOptions}
                                  name="repeat_type" />
                            </div>

                          </div>
                          <div className="form-group col-3">
                            <label className="mb-0 text-sm opacity-75 text-truncate">Starts At</label>
                            <div className="input-group">
                              <div className="w-100">
                                <FormInputs
                                  type="SelectList" id="" className="form-control form-control-solid" value={ScheduleForm["starts_at"]} changeHandler={(value, e) => ScheduleFormHandler(value, "starts_at", e)}
                                  options={ScheduleForm["repeat_type"] === "Day(s)" ? days : ScheduleForm["repeat_type"] === "Month(s)" ? months : Weekday}
                                  name="starts_at" />

                              </div>

                            </div>
                          </div>

                          <div className="form-group col-6 ">
                            <label className="mb-0 text-sm opacity-75 text-truncate">Start Date & Time</label>
                            <div className="row">
                              {/* <input type="datetime-local" id="" className="form-control " placeholder="Set Data & Time" value="" />    */}
                             <div className='col-6'> <FormInputs
                                type="Date" required="true" id="" className="form-control" placeholder="Set Date" value={ScheduleForm["start_date"]} changeHandler={(value, e) => ScheduleFormHandler(value, "start_date", e)}
                              />
                              {isSet(validation["start_date"], "") !== "" ? (
                                <span className="text-danger m-1">
                                  {isSet(validation["start_date"], "")}
                                </span>
                              ) : (
                                ""
                              )}
                              </div>
                              <div className='col-6'> 
                              <FormInputs
                                type="SelectSearchList" required="true" id="" className="form-control" placeholder="Set Time" value={ScheduleForm["start_time"]} changeHandler={(value, e) => ScheduleFormHandler(value, "start_time", e)}
                                isAsync="true"
                                options={[{ 'label': getCurrentTime(), value: getCurrentTime() }]}
                                loadCallBack={(val, callback) => fetchTimeInterval(val, callback)}
                                name="start_time"
                              />
                              {isSet(validation["start_time"], "") !== "" ? (
                                <span className="text-danger m-1">
                                  {isSet(validation["start_time"], "")}
                                </span>
                              ) : (
                                ""
                              )}
                              </div>
                            </div>
                          </div>
                          <div className="form-group col-4 ">
                            <label className="mb-0 text-sm opacity-75 text-truncate">Ends</label>
                            <div className="row">
                              <div className="input-group border-bottom col-12">
                                <label className="m-0 text-md">
                                  <div className="form-check">
                                    <FormInputs
                                      type="Radio" id="" name="ends_type" className="form-check-input" placeholder="" value={ScheduleForm["ends_type"] === "Never"} changeHandler={(e) => endsHanlder("Never", "ends_type", e)}
                                    /> Never
                                  </div>
                                </label>
                              </div>
                              <div className="input-group  border-bottom col-4 py-2 align-items-center">
                                <label className="m-0 text-md">
                                  <div className="form-check">
                                    <FormInputs
                                      type="Radio" id="1" name="ends_type" className="form-check-input" value={ScheduleForm["ends_type"] === "On"} changeHandler={(e) => { endsHanlder("On", "ends_type", e) }}
                                    /> On
                                  </div>
                                  
                                </label>
                              </div>
                              <div className="input-group  border-bottom col-8 py-2 align-items-center">
                                {ScheduleForm["ends_type"] === "On" &&
                                <>
                                  <FormInputs
                                    type="Date" id="2" required="true" className="form-control" placeholder="Set Date" value={ScheduleForm["ends_date"]} changeHandler={(value, e) => ScheduleFormHandler(value, "ends_date", e)}
                                  />
                                    {isSet(validation["ends_date"], "") !== "" ? (
                                      <span className="text-danger m-1">
                                        {isSet(validation["ends_date"], "")}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                    </>
                                }
                              </div>
                              <div className="input-group  border-bottom col-4 py-2 align-items-center">
                                <label className="m-0 text-md">
                                  <div className="form-check">
                                    <FormInputs
                                      type="Radio" id="3" name="ends_type" className="form-check-input" value={ScheduleForm["ends_type"] === "Once"} changeHandler={(value, e) => { ScheduleFormHandler("Once", "ends_type", e) }}
                                    /> Once
                                  </div>
                                </label>
                              </div>
                              <div className="input-group  border-bottom col-8 py-2 align-items-center">
                                {ScheduleForm["ends_type"] === "Once" && <><FormInputs
                                  type="Number" id="" className="form-control" placeholder="" value={ScheduleForm["end_time"]} changeHandler={(value, e) => ScheduleFormHandler(value, "end_time", e)}
                                />    &nbsp; Time( s )
                                
                                  </>
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>}
                      {activeTab === 'CRON' && <div className="tab-pane fade show active" id="cron-exp"  >
                        <div className="form-group col-4 px-0 pt-3">
                          <label className="mb-0 text-sm opacity-75 text-truncate">Cron Expression</label>
                          <div className="input-group ">
                            <FormInputs
                              type="TextInput" id="3" name="custom_cron_expression" placeholder="* * * * *" className="form-control form-control-solid" value={ScheduleForm["custom_cron_expression"]} changeHandler={(value, e) => { ScheduleFormHandler(value, "custom_cron_expression", e) }}
                            />
                             {isSet(validation["custom_cron_expression"], "") !== "" ? (
                                <span className="text-danger m-1">
                                  {isSet(validation["custom_cron_expression"], "")}
                                </span>
                              ) : (
                                ""
                              )}
                          </div>
                          <div>
                            <label>
                              <a className="font-weight-bold text-warning" target="_blank" href="https://crontab.guru/">Generate
                                Expression Here
                              </a>
                            </label>
                          </div>
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center modal-footer">
          <a className="btn btn-primary btn-sm" title={props.payload ? "Update" : "Save"} onClick={handleSave} >{props.payload ? "Update" : "Save"}</a>
        </Modal.Footer>
      </div>
    </Modal>
  )
}
function getNumberOptions() {
  return [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" }
  ];
}
function getRepeatTypeOptions() {
  return [
    { label: "Select", value: "" },
    { label: "Day(s)", value: "Day(s)" },
    { label: "Month(s)", value: "Month(s)" },
    { label: "Week(s)", value: "Week(s)" }
  ]
}
function getDays() {
  return [
    { label: "Select", value: "" },
    { label: "Everyday", value: "Everyday" },
    { label: "Even Days", value: "Even Days" },
    { label: "Odd Days", value: "Odd Days" },
    { label: "Every 5 Days", value: "Every 5 Days" },
    { label: "Every 10 Days", value: "Every 10 Days" },
    { label: "Every Half Month", value: "Every Half Month" }
  ]
}
function getWeekday() {
  return [
    { label: "Select", value: "" },
    { label: "Every Weekday", value: "Every Weekday" },
    { label: "Monday - Friday", value: "Monday - Friday" },
    { label: "Weekend Days", value: "Weekend Days" }
  ]
}
function getMonths() {
  return [
    { label: "Select", value: "" },
    { label: "Every Month", value: "Every Month" },
    { label: "Every Even Month", value: "Every Even Month" },
    { label: "Every Odd Month", value: "Every Odd Month" },
    { label: "Every 4 Months", value: "Every 4 Months" },
    { label: "Every 6 Months", value: "Every 6 Months" }
  ]
}
export default WithDropdownState(withReduxState(WithRoutify(AddRandomVisitScheduler))); 